import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Moon, Heart } from 'lucide-react';
export function EmotionalStory() {
  return <section className="py-24 bg-warm-deep relative overflow-hidden" data-id="element-53">
      {/* Subtle texture/pattern overlay could go here */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-px bg-gradient-to-r from-transparent via-brown/10 to-transparent" data-id="element-54" />

      <div className="max-w-3xl mx-auto px-6 md:px-8 text-center" data-id="element-55">
        <FadeIn data-id="element-56">
          <div className="flex justify-center mb-8" data-id="element-57">
            <div className="w-16 h-16 rounded-full bg-cream flex items-center justify-center shadow-sm text-gold" data-id="element-58">
              <Moon size={28} strokeWidth={1.5} data-id="element-59" />
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-60">
          <p className="text-2xl md:text-3xl font-heading italic text-brown mb-10 leading-relaxed" data-id="element-61">
            "Son las 2:00 AM. La casa por fin está en silencio, pero tu mente no
            se apaga."
          </p>
        </FadeIn>

        <div className="space-y-8 text-lg md:text-xl text-brown-light leading-relaxed text-left" data-id="element-62">
          <FadeIn delay={0.2} data-id="element-63">
            <p data-id="element-64">
              Repasas la lista de pendientes, sientes esa presión en el pecho y
              te preguntas cuánto tiempo más vas a poder aguantar este ritmo
              antes de colapsar.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-65">
            <p data-id="element-66">
              Sé exactamente cómo se siente. Soy mamá soltera, emigrante y vivo
              con TDAH. Sé lo que es fingir que "estás bien" porque la vida te
              obligó a ser fuerte, mientras por dentro sientes que te estás
              rompiendo.
            </p>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-67">
            <div className="my-12 p-8 bg-cream rounded-2xl shadow-sm border border-warm-deeper/50 relative" data-id="element-68">
              <div className="absolute -top-4 -left-4 text-gold/20" data-id="element-69">
                <Heart size={64} fill="currentColor" data-id="element-70" />
              </div>
              <p className="text-xl md:text-2xl font-heading text-brown text-center relative z-10" data-id="element-71">
                No estás loca, ni eres una mala madre:{' '}
                <br className="hidden md:block" data-id="element-72" />
                <span className="text-gold font-medium" data-id="element-73">
                  simplemente tu sistema nervioso se quedó atrapado en el "Modo
                  Supervivencia".
                </span>
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.5} data-id="element-74">
            <p data-id="element-75">
              He diseñado este método de 30 días no como una "tarea más" para tu
              lista, sino como un{' '}
              <strong className="font-semibold text-brown" data-id="element-76">
                mapa de rescate
              </strong>
              . He volcado aquí las herramientas reales que me sacaron del
              abismo emocional y me devolvieron la paciencia con mis hijos y la
              paz conmigo misma.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}